if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      // const formData = new FormData(this.form);
      // formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      // formData.append('sections_url', window.location.pathname);
      // config.body = formData;

      var data = {}, qty = this.form.querySelector('[name="quantity"]') ? this.form.querySelector('[name="quantity"]').value : 1;
      const items = [];

      if (document.querySelector('.size-input-wrapper .matrix-input-container')){
        var sizeCheckbox = document.querySelectorAll('.size-input-wrapper .matrix-input-container');
        sizeCheckbox.forEach((v) => {
          if (v.querySelector('input.size-input').value != ''){
            items.push({
              "quantity": v.querySelector('input.size-input').value,
              "id": parseInt(v.querySelector('input.size-input').getAttribute('data-variant-id')),
            });
          }
        });
      } else {
        items.push({
          "quantity": qty,
          "id": parseInt(this.form.querySelector('[name=id]').value),
        });
      }

      data['items'] = items;
      data['sections'] = this.cartNotification.getSectionsToRender().map((section) => section.id);
      data['sections_url'] = window.location.pathname;

      const body = JSON.stringify(data);

      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          if (document.querySelectorAll('.size-input-wrapper .matrix-input-container').length > 0){
            var sizeCheckbox = document.querySelectorAll('.size-input-wrapper .matrix-input-container');
            sizeCheckbox.forEach((v) => {
                if (v.querySelector('input.size-input')) v.querySelector('input.size-input').value = '';
                if (v.querySelector('.size-input-label')) v.querySelector('.size-input-label').style.display = 'block';
            });
          }
          
          setTimeout(function(){
            if(getCookie('axism_modal') != 'closed' && $('.cart-login-popup').length > 0){
               $('.axism_modal').addClass('is-active-popup');
               $('body').addClass('active-axism_modal');
            }  
          }, 2000);
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
